import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import { Container } from '@ttstr/components';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
      <Container>
        <Row>
          <hr />
          <Col md="4">
            <h5 className="mb-3">{t(`FOOTER.HEAD1`)}</h5>
            <ul className="list-unstyled">
              <li>
                <Link to="/imprint">{t(`IMPRINT.TITLE`)}</Link>
              </li>
              <li>
                <Link to="/privacy">{t(`PRIVACY.TITLE`)}</Link>
              </li>
              <li>
                <Link to="/terms">{t(`TERMS_AND_CONDITIONS.TITLE`)}</Link>
              </li>
              <li>
                <a href="https://tickettoaster.de/retouren">Informationen zu Versand und Rückgabe</a>
              </li>
            </ul>
          </Col>
          <Col md="4">
            <h5 className="mb-3">{t(`FOOTER.HEAD2`)}</h5>
            <p>
              <a className="font-weight-bolder" href="https://silvesterinconcert.com/#faq">
                Antworten auf häufige Fragen
              </a>
            </p>

            <p>Bei Fragen zu Ihrer Bestellung wende Sie sich bitte an den teamtoaster Kundenservice:</p>
            <p>
              Tel.: +49 561 350 296 28 - 0<br />
              <a href="mailto:hallo@tickettoaster.de">hallo@tickettoaster.de</a>
            </p>
          </Col>
          <Col md="4" className="text-sm-right"></Col>
        </Row>
        <Row className="mt-5 d-flex align-items-center">
          <Col md="8" className="align-items-end mt-4 text-left text-muted copyright">
            <p className="mb-0">
              <a href="https://www.silvesterinconcert.com">Silvester in Concert 2025</a>
              <br />
              powered by <a href="https://www.tickettoaster.de">tickettoaster Direct-To-Fan Commerce</a>
            </p>
          </Col>
          <Col md="4" className="align-items-end mt-2 text-right">
            <a href="https://tickettoaster.de" target="_blank" rel="noreferrer noopener">
              <img
                src={require('@ttstr/assets/images/logo_teamtoaster_full_white.png')}
                alt="powered by tickettoaster"
                title="powered by tickettoaster"
                width="133px"
                loading="lazy"
              />
            </a>
          </Col>
        </Row>
      </Container>
  );
};

export default React.memo(Footer);
